module.exports = __webpack_public_path__ + "assets/img/kv-911f51e6.jpg";